export default Buffer.from("A+BSQ29weXJpZ2h0IDE5OTAtMjAwOSBBZG9iZSBTeXN0ZW1zIEluY29ycG9yYXRlZC4KQWxsIHJpZ2h0cyByZXNlcnZlZC4KU2VlIC4vTElDRU5TReEKR0JLcC1FVUMtSGEUoaIAhD8AAIQ+BgCEVgABvBgAAIRXBA2ERj4AvBqDIgCEQgYBhEQCAIQ9AQC8GwsBhEABALwcAQCEQxsAvB0BALweAQCEWBsAhFQBAIRVAAC8Hw==", "base64")


//////////////////
// WEBPACK FOOTER
// ./~/vue-pdf-signature/src/buffer-loader.js!./~/pdfjs-dist-sign/cmaps/GBKp-EUC-V.bcmap
// module id = 644
// module chunks = 502